import Tile from './Tile';
import './Tile.scss';

export default Tile;